import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M11.029 11.46 3 7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2l-8.029 4.46a2 2 0 0 1-1.942 0m10.531 5.893a6.19 6.19 0 0 1-3.913-3.913.155.155 0 0 0-.294 0 6.19 6.19 0 0 1-3.913 3.913.155.155 0 0 0 0 .294 6.19 6.19 0 0 1 3.913 3.913.155.155 0 0 0 .294 0 6.19 6.19 0 0 1 3.913-3.913.155.155 0 0 0 0-.294"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M3 9v8a2 2 0 0 0 2 2h6.93c-1.021-1.053-.729-3.009.878-3.544a4.19 4.19 0 0 0 2.648-2.648c.655-1.965 3.433-1.965 4.088 0A4.2 4.2 0 0 0 21 14.83V9l-8.029 4.46a2 2 0 0 1-1.942 0z",
      clipRule: "evenodd"
    }
  )
);
var SvgGenerateEmailFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var GenerateEmailFilled_default = SvgGenerateEmailFilled;

export { GenerateEmailFilled_default as default };
